import { render, staticRenderFns } from "./RouteList.vue?vue&type=template&id=4ba2c852&scoped=true"
import script from "./RouteList.vue?vue&type=script&lang=js"
export * from "./RouteList.vue?vue&type=script&lang=js"
import style0 from "./RouteList.vue?vue&type=style&index=0&id=4ba2c852&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba2c852",
  null
  
)

export default component.exports